import { httpsCallable } from 'firebase/functions';
import { functions } from '../FirebaseConfig';
import { SellerPermissions } from '../models/SellerType';

class SellerService {
  /**
   * Create a seller account
   * @param {string} email
   * @param {string} password
   * @param {string} name
   * @param {string} phone
   * @param {string} parentUserId - ID of the parent user
   * @param {SellerPermissions} permissions
   */
  static createSeller = async (
    email: string,
    password: string,
    name: string,
    phone: string,
    parentUserId: string,
    permissions: SellerPermissions,
    promoCode?: string,
  ) => {
    try {
      const createSellerFunction = httpsCallable(functions, 'seller-createSeller');
      const result = await createSellerFunction({
        email,
        password,
        name,
        phone,
        parentUserId,
        permissions,
        promoCode,
      });

      return result.data;
    } catch (error: any) {
      console.error('Erreur lors de la création du vendeur:', error);
      throw error;
    }
  };

  /**
   * Delete a seller account
   * @param {string} parentUserId - ID of the parent user
   * @param {string} sellerId - ID of the seller to delete
   * @returns {Promise<{success: boolean}>}
   */
  static deleteSeller = async (parentUserId: string, sellerId: string): Promise<{success: boolean}> => {
    try {
      const deleteSellerFunction = httpsCallable<any, {success: boolean}>(functions, 'seller-deleteSeller');
      const result = await deleteSellerFunction({
        parentUserId,
        sellerId,
      });

      return result.data;
    } catch (error: any) {
      console.error('Erreur lors de la suppression du vendeur:', error);
      throw error;
    }
  };

  /**
   * Transfer a client to a new owner
   * @param {string} originalOwnerId - ID of the current owner
   * @param {string} newOwnerId - ID of the new owner
   * @param {string} clientId - ID of the client to transfer
   * @returns {Promise<{success: boolean}>}
   */
  static transferClient = async (
    originalOwnerId: string,
    newOwnerId: string,
    clientId: string,
  ): Promise<{success: boolean}> => {
    try {
      const transferClientFunction = httpsCallable<any, {success: boolean}>(functions, 'seller-transferClient');
      const result = await transferClientFunction({
        originalOwnerId,
        newOwnerId,
        clientId,
      });

      return result.data;
    } catch (error: any) {
      console.error('Erreur lors du transfert du client:', error);
      throw error;
    }
  };
}

export default SellerService;
